<div class="container-fluid bg-color p-2 mb-5">
    <div class="row">
        <div class="classroom-header-card position-relative">
            <img [src]="_classroom.cover_image_url" class="cover-image" alt="Cover Image" />
            <div class="header-overlay"></div>
            <div class="header-content d-flex justify-content-between align-items-start px-4 pt-4">
                <div class="left-header text-white">
                    <div class="d-flex align-items-center">
                        <i class="bi bi-arrow-left-short back-arrow pr-5 ms-1"
                            [routerLink]="['/student-dashboard/classrooms']"></i>
                        <h2 class="class-title">{{ _classroom.name || "N/A" }}</h2>
                    </div>
                    <p class="class-subject">{{ _classroom.subject || "N/A" }}</p>
                    <div class="students-badge">
                        <mat-icon class="text-white">groups</mat-icon>
                        <span>{{ _classroom.student_count || 0 }} Students</span>
                    </div>
                </div>
                <div class="taught-by-card">
                    <span class="taught-by-label">Taught by</span>
                    <span class="teacher-name">{{ _classroom.teacher_name || "N/A" }}</span>
                </div>
            </div>
        </div>

        <app-student-classroom-navbar></app-student-classroom-navbar>
        <!-- <router-outlet></router-outlet> -->
    </div>
</div>